import { styled, Step, StepConnector, stepConnectorClasses, Typography } from '@mui/material';

export const StyledStep = styled(Step)(() => ({
  '& .MuiStepLabel-root .Mui-completed': {
    color: 'success.main',
  },
  '& .MuiStepLabel-label.Mui-completed': {
    color: 'black',
  },
  '& .MuiStepLabel-root .Mui-active': {
    color: '#0D1B27DE',
  },
  '& .MuiButtonBase-root': {
    padding: '12px 8px',
    margin: '-12px -8px',
  },
}));

export const StyledConnector = styled(StepConnector)(() => ({
  [`& .${stepConnectorClasses.line}`]: {
    width: '48px',
    marginLeft: 8,
    marginRight: 8,
  },
}));

export const StyledStepLabel = styled(Typography)(() => ({
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '20px',
}));
